/** Artist Corner hub (feature cards: Art History, Magic Studio, etc.) */
export const ARTIST_CORNER_PATH = '/my-art-world';

export const HOME_MARKETING_PATH = '/home';

/** Routes that share the same studio entitlement as Artist Corner */
export const STUDIO_HUB_PATHS = new Set([
  ARTIST_CORNER_PATH,
  '/my-art-history',
  '/my-art-stories',
  '/activity-dashboard',
  '/learn-art-history',
]);

export function isStudioHubPath(pathname = '') {
  if (!pathname) return false;
  if (STUDIO_HUB_PATHS.has(pathname)) return true;
  if (pathname.startsWith('/learn-art-history')) return true;
  return false;
}

export function goToArtistCorner(navigate, event) {
  event?.preventDefault?.();
  event?.stopPropagation?.();
  navigate(ARTIST_CORNER_PATH);
}

export function goToHomeMarketing(navigate, event) {
  event?.preventDefault?.();
  event?.stopPropagation?.();
  navigate(HOME_MARKETING_PATH);
}
